package pl.mothdigital.neuronowi.components.sections.footer

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.*
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.cssRem
import pl.mothdigital.neuronowi.common.resources.*

val FooterLogoImageStyle = CssStyle.base {
    Modifier
        .display(DisplayStyle.Block)
        .height(5.cssRem)
        .padding(top = (1.5).cssRem)
}

@Composable
fun FooterLogoImage() {
    Image(
        src = ImageResources.navHeaderLogo.src,
        description = ImageResources.navHeaderLogo.description,
        modifier = FooterLogoImageStyle.toModifier(),
    )
}
